import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("Page error:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div data-testid="page-error" className="grid min-h-[60vh] place-items-center px-6 text-center">
        <div>
          <p className="font-['Geist',sans-serif] text-4xl font-light tracking-[-0.04em]">Something went wrong.</p>
          <button onClick={() => window.location.reload()} className="label draw-link mt-6">Reload the page</button>
        </div>
      </div>
    );
  }
}
